var _style, _script, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHardCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#F79317;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _script || (_script = /*#__PURE__*/React.createElement("script", {
    "data-extension-id": "dlcobpjiigpikoobohmabehhmhfoodbb",
    id: "argent-x-extension",
    xmlns: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,7H1v16h22V7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,18c1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3S10.3,18,12,18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,4h16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,1h8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardCap);
export default __webpack_public_path__ + "static/media/hard-cap.f3f70ad13bd08add730917c7421235ef.svg";
export { ForwardRef as ReactComponent };